export type LlmPricing = {
  input_cost_per_million_tokens: number;
  output_cost_per_million_tokens: number;
};

export const LLM_PRICING: { [key: string]: LlmPricing } = {
  // Gemini
  "gemini/gemini-2.0-flash-lite": {
    input_cost_per_million_tokens: 0.075,
    output_cost_per_million_tokens: 0.3,
  },
  "gemini/gemini-flash-lite-latest": {
    input_cost_per_million_tokens: 0.1,
    output_cost_per_million_tokens: 0.4,
  },
  "gemini/gemini-2.0-flash": {
    input_cost_per_million_tokens: 0.1,
    output_cost_per_million_tokens: 0.4,
  },

  "gemini/gemini-2.5-flash": {
    input_cost_per_million_tokens: 0.3,
    output_cost_per_million_tokens: 2.5,
  },
  "gemini/gemini-flash-latest": {
    input_cost_per_million_tokens: 0.3,
    output_cost_per_million_tokens: 2.5,
  },

  "gemini/gemini-2.5-flash-lite-preview-06-17": {
    input_cost_per_million_tokens: 0.1,
    output_cost_per_million_tokens: 0.4,
  },

  "gemini/gemini-2.5-flash-preview-04-17": {
    input_cost_per_million_tokens: 0.15,
    output_cost_per_million_tokens: 0.6,
  },

  "gemini/gemini-2.5-flash-preview-05-20": {
    input_cost_per_million_tokens: 0.15,
    output_cost_per_million_tokens: 0.6,
  },

  "gemini/gemini-2.5-pro-preview-05-06": {
    input_cost_per_million_tokens: 1.25,
    output_cost_per_million_tokens: 2.5,
  },

  "gemini/gemini-2.5-pro": {
    input_cost_per_million_tokens: 1.25,
    output_cost_per_million_tokens: 10.0,
  },

  // OpenAI
  "openai/gpt-4.1": {
    input_cost_per_million_tokens: 2.0,
    output_cost_per_million_tokens: 8.0,
  },
  "openai/gpt-4.1-mini": {
    input_cost_per_million_tokens: 0.4,
    output_cost_per_million_tokens: 1.6,
  },
  "openai/gpt-4.1-nano": {
    input_cost_per_million_tokens: 0.1,
    output_cost_per_million_tokens: 0.4,
  },
  "openai/gpt-4o": {
    input_cost_per_million_tokens: 2.5,
    output_cost_per_million_tokens: 10.0,
  },
  "openai/o4-mini": {
    input_cost_per_million_tokens: 1.1,
    output_cost_per_million_tokens: 4.4,
  },
  "openai/o3": {
    input_cost_per_million_tokens: 10.0,
    output_cost_per_million_tokens: 40.0,
  },
  "openai/gpt-4o-mini": {
    input_cost_per_million_tokens: 0.15,
    output_cost_per_million_tokens: 0.6,
  },
  "openai/o1": {
    input_cost_per_million_tokens: 15.0,
    output_cost_per_million_tokens: 60.0,
  },
  "openai/o1-pro": {
    input_cost_per_million_tokens: 150.0,
    output_cost_per_million_tokens: 600.0,
  },
  "openai/o1-mini": {
    input_cost_per_million_tokens: 1.1,
    output_cost_per_million_tokens: 4.4,
  },
  "openai/o1-preview": {
    input_cost_per_million_tokens: 1.1,
    output_cost_per_million_tokens: 4.4,
  },
  "openai/gpt-4.5-preview": {
    input_cost_per_million_tokens: 75.0,
    output_cost_per_million_tokens: 150.0,
  },
  "openai/gpt-5-nano": {
    input_cost_per_million_tokens: 0.05,
    output_cost_per_million_tokens: 0.4,
  },
  "openai/gpt-5-mini": {
    input_cost_per_million_tokens: 0.25,
    output_cost_per_million_tokens: 2.0,
  },
  "openai/gpt-5": {
    input_cost_per_million_tokens: 1.25,
    output_cost_per_million_tokens: 10.0,
  },
};
